import { render, staticRenderFns } from "./WarningCenterNew.vue?vue&type=template&id=39daa8ca&scoped=true&"
import script from "./WarningCenterNew.vue?vue&type=script&lang=js&"
export * from "./WarningCenterNew.vue?vue&type=script&lang=js&"
import style0 from "./WarningCenterNew.vue?vue&type=style&index=0&id=39daa8ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39daa8ca",
  null
  
)

export default component.exports